export const dispatchType = {
  default: '',
  card: 'card p-ds-16 py-ds-12 bg-light border border-default',
};
